import React from 'react';
import styled from 'styled-components';
import ProjectGrind from '../Projects/ProjectGrind';
import ProjectUts from '../Projects/ProjectUts';
import Title from './Title';
import ProjectAuto from '../Projects/ProjectAuto';
import ProjectVolunteer from '../Projects/ProjectVolunteer';
import ProjectProdayauto from '../Projects/ProjectProdayauto';
import ProjectFlowers from '../Projects/ProjectFlowers';

const Container = styled.section`
    grid-row: 3;
    grid-column: 2;
    align-self: center;
`;

const Projects = () => {
    return (
        <Container id='projects'>
            {Title('02', 'PROJ')}
            <ProjectProdayauto />
            <ProjectFlowers />
            <ProjectVolunteer />
            <ProjectAuto />
            <ProjectGrind />
            <ProjectUts />
        </Container>
    );
};

export default Projects;
